import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CountrySelectComponent } from './country-select/country-select.component';
import { LoaderCssComponent } from './loader-css/loader-css.component';
import { BtnIconEditComponent } from './buttons/btn-icon-edit/btn-icon-edit.component';
import { BtnIconDelComponent } from './buttons/btn-icon-del/btn-icon-del.component';
import { MatTreeModule } from '@angular/material/tree';
import { MatIconModule } from '@angular/material/icon';
import { CdkTreeModule } from '@angular/cdk/tree';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatSortModule } from '@angular/material/sort';
import { ItemTypeTreeIconsComponent } from './item-type-tree-icons/item-type-tree-icons.component';
import { AddBtnComponent } from './buttons/add-btn/add-btn.component';
import { DeleteNodeComponent } from './delete-node/delete-node.component';
import { EditNodeComponent } from './edit-node/edit-node.component';
import { ConfirmModalComponent } from './modals/confirm-modal/confirm-modal.component';
import { CreateEditUserModalComponent } from './modals/create-edit-user-modal/create-edit-user-modal.component';
import { InfoModalComponent } from './modals/info-modal/info-modal.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input-gg';
import { PassChangesModalComponent } from './modals/pass-changes-modal/pass-changes-modal.component';
import { CreateEditOrgCustomerModalComponent } from './modals/create-edit-org-customer-modal/create-edit-org-customer-modal.component';
import { LangChangesModalComponent } from './modals/lang-changes-modal/lang-changes-modal.component';
import { LogoutModalComponent } from './modals/logout-modal/logout-modal.component';
import { PatientIdModalComponent } from './modals/patient-id-modal/patient-id-modal.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ActivityLogModalComponent } from './modals/activity-log-modal/activity-log-modal.component';
import { BtnIconRestoreComponent } from './buttons/btn-icon-restore/btn-icon-restore.component';
import { BtnUrlSourceComponent } from './buttons/btn-url-source/btn-url-source.component';
import { DownloadingModalComponent } from './modals/downloading-modal/downloading-modal.component';
import { BtnOrganizationSettingsComponent } from './buttons/btn-organization-settings/btn-organization-settings.component';
import { OrganizationSettingsModalComponent } from './modals/organization-settings-modal/organization-settings-modal.component';
import { PaginatorI18n } from './paginator/paginatorI18n';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { SectraUrlModalComponent } from './modals/sectra-url-modal/sectra-url-modalcomponent';

@NgModule({
  declarations: [
    CountrySelectComponent,
    LoaderCssComponent,
    BtnIconEditComponent,
    BtnIconDelComponent,
    ItemTypeTreeIconsComponent,
    AddBtnComponent,
    DeleteNodeComponent,
    EditNodeComponent,
    ConfirmModalComponent,
    CreateEditUserModalComponent,
    InfoModalComponent,
    SectraUrlModalComponent,
    PassChangesModalComponent,
    CreateEditOrgCustomerModalComponent,
    LangChangesModalComponent,
    LogoutModalComponent,
    PatientIdModalComponent,
    ActivityLogModalComponent,
    BtnIconRestoreComponent,
    BtnUrlSourceComponent,
    BtnOrganizationSettingsComponent,
    DownloadingModalComponent,
    OrganizationSettingsModalComponent
  ],
  imports: [
    CommonModule,
    MatTreeModule,
    MatIconModule,
    CdkTreeModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDaterangepickerMd,
    MatButtonModule,
    TranslateModule,
    NgSelectModule,
    MatSortModule,
    MatPaginatorModule,
    MatTableModule,
    NgxIntlTelInputModule,
    MatRadioModule,
    MatCheckboxModule
  ],
  exports:[
    CountrySelectComponent,
    LoaderCssComponent,
    BtnIconEditComponent,
    BtnIconDelComponent,
    ItemTypeTreeIconsComponent,
    AddBtnComponent,
    DeleteNodeComponent,
    EditNodeComponent,
    ConfirmModalComponent,
    CreateEditUserModalComponent,
    InfoModalComponent,
    SectraUrlModalComponent,
    PassChangesModalComponent,
    CreateEditOrgCustomerModalComponent,
    LangChangesModalComponent,
    LogoutModalComponent,
    PatientIdModalComponent,
    ActivityLogModalComponent,
    BtnIconRestoreComponent,
    BtnUrlSourceComponent,
    BtnOrganizationSettingsComponent,
    DownloadingModalComponent,
    OrganizationSettingsModalComponent
  ],
  providers: [
    {
      provide: MatPaginatorIntl, deps: [TranslateService],
      useFactory: (translateService: TranslateService) => new PaginatorI18n(translateService).getPaginatorIntl()
    }
  ]
})
export class ComponentsModule { }
